import { apiClient } from './client';

/** Subconjunto de `GeneralExpense` (aws-serverless/src/models/expense.model.ts) que usa la bandeja. */
export interface PendingExpense {
  expenseId: string;
  category: string;
  description: string;
  occurredAt: string;
  counterpartyName?: string;
  currency: string;
  totalAmount: number;
  baseCurrency: string;
  baseTotal: number;
  scope: 'TENANT' | 'RANCHO' | 'LOTE';
  createdBy: string;
  /** Nombre resuelto en servidor a partir de createdBy — null si no se pudo resolver */
  createdByName?: string | null;
  status: 'PENDING_APPROVAL' | 'CONFIRMED' | 'REJECTED' | 'VOID' | 'EXPIRED';
  createdAt: string;
}

/** GET /expenses/pending: gastos por aprobar visibles para quien tiene `expenses:approve`. */
export async function fetchPendingExpenses(_tenantId: string): Promise<PendingExpense[]> {
  const res = await apiClient.get(`/api/expenses/pending`);
  return res.data.items;
}

export async function approveExpense(_tenantId: string, expenseId: string): Promise<void> {
  await apiClient.post(`/api/expenses/${expenseId}/approve`);
}

export async function rejectExpense(_tenantId: string, expenseId: string, reason?: string): Promise<void> {
  await apiClient.post(`/api/expenses/${expenseId}/reject`, reason ? { reason } : {});
}

/** GET /expenses/summary (aws-serverless/src/utils/expense-summary.ts). Solo CONFIRMED, en moneda base. */
export interface ExpenseSummary {
  from: string;
  to: string;
  baseCurrency: string;
  count: number;
  total: number;
  byCategory: Record<string, number>;
  byCounterparty: Array<{ counterpartyId?: string; name: string; total: number }>;
  byRancho: Record<string, number>;
  byMonth: Record<string, number>;
  excludedOtherBaseCurrency: number;
  pendingCount: number;
  pendingTotal: number;
}

export interface ExpenseSummaryFilters { from?: string; to?: string; ranchoId?: string; loteId?: string }

export async function fetchExpenseSummary(_tenantId: string, filters: ExpenseSummaryFilters = {}): Promise<ExpenseSummary> {
  const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => !!v));
  const res = await apiClient.get(`/api/expenses/summary`, { params });
  return res.data;
}
